import {IAsset} from '../schema';

export const assetHasRelationships = (asset?: IAsset): asset is IAsset => {
	return !!asset && asset.relatedAvailable;
};
